import { GalleryImageField } from '@monoimin/sb-types';

import { pickFirstImageFromGalleryField } from './pickFirstImageFromGalleryField';

export const getGalleryImageDimensions = (item: GalleryImageField) => {
  const pickedImage = pickFirstImageFromGalleryField(item);

  if (!pickedImage) {
    return { width: undefined, height: undefined };
  }

  return {
    width: pickedImage.width,
    height: pickedImage.height,
  };
};

export default getGalleryImageDimensions;
